import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Offer() {
  return <section id="offer" className="py-24 px-6 bg-[#111113] relative overflow-hidden" data-id="element-113">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-96 bg-amber-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-114" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-115">
        <FadeIn data-id="element-116">
          <div className="bg-zinc-950 border border-amber-500/30 rounded-3xl p-8 sm:p-12 text-center shadow-[0_0_50px_rgba(245,158,11,0.05)]" data-id="element-117">
            <h2 className="text-2xl sm:text-3xl font-medium text-white mb-8 leading-snug" data-id="element-118">
              Recuperar tu enfoque y tu masculinidad no debería costar una
              fortuna.
            </h2>

            <p className="text-zinc-400 mb-8" data-id="element-119">
              Accede a todo el ecosistema del Protocolo Dopamina Cero hoy mismo.
            </p>

            <div className="mb-10" data-id="element-120">
              <span className="block text-amber-500 font-bold uppercase tracking-widest text-sm mb-2" data-id="element-121">
                Inversión Única
              </span>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-122">
                <span className="text-2xl text-zinc-500 line-through font-semibold" data-id="element-123">
                  $17 USD
                </span>
                <span className="bg-red-500/20 text-red-400 text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-124">
                  -62% OFF
                </span>
              </div>
              <div className="flex items-start justify-center gap-1" data-id="element-125">
                <span className="text-3xl font-bold text-white mt-2" data-id="element-126">$</span>
                <span className="font-bebas text-8xl text-white leading-none" data-id="element-127">
                  6.39
                </span>
                <span className="text-xl font-bold text-zinc-500 mt-auto mb-2" data-id="element-128">
                  USD
                </span>
              </div>
            </div>

            <motion.a href="https://renacelibre.com/cart/42860714426445:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-amber-500 text-zinc-950 font-bold text-xl py-5 rounded-xl uppercase tracking-wide shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] transition-shadow mb-6" data-id="element-129">
              Quiero Reiniciar Mi Cerebro Ahora
            </motion.a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-zinc-400" data-id="element-130">
              <div className="flex items-center gap-2" data-id="element-131">
                <LockIcon className="w-4 h-4 text-zinc-500" data-id="element-132" />
                <span data-id="element-133">Pago 100% Seguro</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-zinc-700 rounded-full" data-id="element-134" />
              <div className="flex items-center gap-2" data-id="element-135">
                <ShieldCheckIcon className="w-4 h-4 text-zinc-500" data-id="element-136" />
                <span data-id="element-137">Acceso Inmediato</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}